import { combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form';
import { reducer as toastrReducer } from 'react-redux-toastr';

import AuthReducer from '../auth/authReducer';
import DashboardReducer from '../dashboard/dashboardReducer';
import TabReducer from '../common/tab/tabReducer';
import UsuarioReducer from '../usuario/usuarioReducer';
import HospitalReducer from '../hospital/hospitalReducer';
import RadiologistaReducer from '../radiologista/radiologistaReducer';
import ExameReducer from '../exame/exameReducer';
import GrupoFaturamentoReducer from '../grupoFaturamento/grupoFaturamentoReducer';
import GrupoFaturamentoRadiologistaReducer from '../grupoFaturamentoRadiologista/grupoFaturamentoRadiologistaReducer';
import HospitalConvenioReducer from '../hospitalConvenio/hospitalConvenioReducer';
import ContratoReducer from '../contrato/contratoReducer';
import ContratoItemReducer from '../contratoItem/contratoItemReducer';
import ContratoServicoReducer from '../contratoServico/contratoServicoReducer';
import LaudoImportacaoReducer from '../laudoImportacao/laudoImportacaoReducer';
import RelatorioRadiologistaSinteticoReducer from '../relatorioRadiologistaSintetico/relatorioRadiologistaSinteticoReducer';
import RelatorioRadiologistaAnaliticoReducer from '../relatorioRadiologistaAnalitico/relatorioRadiologistaAnaliticoReducer';
import RelatorioHospitalReducer from '../relatorioHospital/relatorioHospitalReducer';

const rootReducer = combineReducers({
	auth: AuthReducer,
	dashboard: DashboardReducer,
	usuario: UsuarioReducer,
	hospital: HospitalReducer,
	radiologista: RadiologistaReducer,
	exame: ExameReducer,
	grupoFaturamento: GrupoFaturamentoReducer,
	grupoFaturamentoRadiologista: GrupoFaturamentoRadiologistaReducer,
	hospitalConvenio: HospitalConvenioReducer,
	contrato: ContratoReducer,
	contratoItem: ContratoItemReducer,
	contratoServico: ContratoServicoReducer,
	laudoImportacao: LaudoImportacaoReducer,
	relatorioRadiologistaSintetico: RelatorioRadiologistaSinteticoReducer,
	relatorioRadiologistaAnalitico: RelatorioRadiologistaAnaliticoReducer,
	relatorioHospital: RelatorioHospitalReducer,
    tab: TabReducer,
    form: formReducer,
    toastr: toastrReducer
});

export default rootReducer;

